import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth'

var _baseURL = window.g.baseURL;
var _fileURL = window.g.fileURL;
// create an axios instance
const service = axios.create({
    baseURL: _baseURL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 1000000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Authorization'] = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        if(!res.code) {
            return response;
        }

        if (res.code === "JWT_CHECK_ERROR" || res.code === "10019") {
            store.dispatch('user/resetToken').then(() => {
                location.reload()
            })
        }
        if (res.code !== "10000") {
            Message({
                message: res.msg || '系统错误',
                type: 'error',
                duration: 5 * 1000
            })

            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res.data
        }
    },
    error => {
        Message({
            message: error.msg || "系统错误",
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service;

// return url prefix
export function getBaseUrl() {
    return _baseURL;
}

export function getFileUrl() {
    return _fileURL;
}
